const setInitalDeltaCustomerIdData = (state, payload = {}) => {
  const {delta_customer_ids} = payload;
  if (delta_customer_ids) {
    const oldCustomerIds = state;
    const newCustomerIds = delta_customer_ids;
    return [...new Set([...oldCustomerIds, ...newCustomerIds])];
  } else return state;
};

export default (state = [], action = {}) => {
  const {payload = {}} = action;
  return setInitalDeltaCustomerIdData(state, payload);
};
